import { config } from "../constant";
import axios from "axios";
import { Cookie, util } from "../utils";
import { API_ROUTE_CONTROLLER } from "../routes";
import { API_HOST } from "../../../config";

export class ApiServices {
  public static getToken() {
    const token: any = Cookie.get();
    let _token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImtyaXNobmFrdW1hci5zQHZlY3RvbmUuY29tIiwicGFzc3dvcmQiOiJrcmlzaG5hQDg2NiIsImRldmljZUlkIjoiMTU1LWhkbmRuLXdldXdpZWUiLCJzaXBMb2dpbklkIjoiNTM2NCIsInJvbGVJZCI6NCwiZG9tYWluSWQiOjMzMjgsImV4dCI6MjA5LCJjb21wYW55SWQiOjMzNjIsImVuZXRlcHJpc2VpZCI6ODAzMiwiaG9zdEFkZHJlc3MiOiI4MDMyLnVyY2hhdC51bmlmaWVkcmluZy5jby51ayIsIm9yZGVySWQiOjExMDE4LCJkaXJVc2VySWQiOjMyNjI0LCJpYXQiOjE2MjM3NTQ3ODd9.cR2-rh9bxex3riXVPlHW69gNRqZzDR8Tt6ewhuC9eXg";
    if (token && typeof token.ssoToken != "undefined" && token.ssoToken) {
      _token = token.ssoToken;
    }
    return _token;
  };

  public static async get(endPoint: any) {
    // const url: any = config().API_SERVICE_URL;
    const token: any = Cookie.get();

    return axios
      .get(`${endPoint}`, {
        headers: {
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        //console.log(error);
        return error;
      });
  }
  public static async getPricing(endPoint: any) {
    const url: any = config().API_PRICING_URL;
    const token: any = Cookie.get();
    return axios
      .get(`${endPoint}`, {
        headers: {
          // appId: config().APP_ID,
          // appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        //console.log(error);
      });
  }
  /**
 * API POST
 *
 * @param   (body:any,url:any)
 * @returns API output.
 */
  public static post(data: any, endPoint: any) {
    //const url: any = config().API_SERVICE_URL;
    const token: any = Cookie.get();
    return axios
      .post(`${endPoint}`, data, {
        headers: {
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
          "Content-Type": 'application/json'
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        //console.log(error);
      });
  }

  public static async put(data: any, endPoint: any) {
    //const url: any = config().API_SERVICE_URL;
    const token: any = Cookie.get();

    return axios
      .put(`${endPoint}`, data, {
        headers: {
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
        },
      })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          return response;
        } else {
          //SignOut();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  public static async patch(data: any, endPoint: any) {
    //const url: any = config().API_SERVICE_URL;
    const token: any = Cookie.get();

    return (
      axios
        //.patch(`${url}${endPoint}`, data, {
        .patch(`${endPoint}`, data, {
          headers: {
            appId: config().APP_ID,
            appSecret: config().APP_SECRET,
            Authorization: this.getToken(),
          },
        })
        .then((response: any) => {
          return response;
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  }

  public static async delete(endPoint: any) {
    //const url: any = config().API_SERVICE_URL;
    const token: any = Cookie.get();

    return axios
      .delete(`${endPoint}`, {
        headers: {
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  public static async sso(_url: any, _body: any) {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
        },
        body: JSON.stringify(_body),
      };
      const response = await fetch(_url, requestOptions);
      const _res = await response.json();
      if (_res) {
        Cookie.set("ssoToken", _res.token, 1);
        // cookies.set('ssoToken', _res.token, { path: '/', maxAge: (24 * 60 * 60 * 365), domain: API_HOST.sso_host });
        // cookies.set('ssoRefreshToken', res.refresh_token, { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });
        // cookies.set('appId', API_HOST.appId, { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });
        // cookies.set('appSecret', API_HOST.appSecret, { path: '/', maxAge: (24 * 60 * 60 * 360), domain: API_HOST.sso_host });
      }
      return _res;
    } catch (error) {
      console.log("Api error:", error);
    }
    return null;
  }

  public static async createSSO(data: any, endPoint: any) {
    //const url: any = config().API_SERVICE_URL;

    const token: any = Cookie.get();
    return axios
      .post(`${endPoint}`, data, {
        headers: {
          "Content-Type": "application/json",
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  public static async ivrGet(endPoint: any) {
    const token: any = Cookie.get();

    return axios
      .get(`${endPoint}`, {
        headers: {
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  public static async reactGet(endPoint: any) {
    const token: any = Cookie.get();

    return axios
      .get(`${endPoint}`, {
        headers: {
          Authorization: this.getToken(),
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  public static async rePost(endPoint: any, _body: any, _token: any) {
    let data = {};
    if (_token !== "") {
      data = {
        method: "POST",
        header: {
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
        },
        body: JSON.stringify(_body),
      };
      console.log("pppppppppppassssssss", data);
    } else {
      data = {
        method: "POST",
        header: {
          "content-type": "application/json",
          Authorization: this.getToken(),
        },
        body: JSON.stringify(_body),
      };
      console.log("assssssss", data);
    }
    return axios
      .post(`${endPoint}`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: this.getToken(),
        },
      })
      .then((response: any) => {
        console.log("rrrrrrrwwwwwrrrrrrrrrr", response);
        return response;
      })
      .catch(function (error) {
        console.log("reeeeeeeeeeeeettttttt", error);
      });
  }

  public static async reactPost(data: any, endPoint: any) {
    // const url: any = config().API_SERVICE_URL;
    return axios
      .post(`${endPoint}`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: this.getToken(),
        },
      })
      .then((response: any) => {
        console.log("innnnnnnnnnnnnnnn", response);
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  public static async urPost(data: any, endPoint: any) {
    //const url: any = config().API_SERVICE_URL;
    const token: any = Cookie.get();
    return axios
      .post(`${endPoint}`, data, {
        headers: {
          // appId: config().APP_ID,
          // appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
          //authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImtyaXNobmFrdW1hci5zQHZlY3RvbmUuY29tIiwicGFzc3dvcmQiOiJrcmlzaG5hQDg2NiIsImRldmljZUlkIjoiMTU1LWhkbmRuLXdldXdpZWUiLCJzaXBMb2dpbklkIjoiNTM2NCIsInJvbGVJZCI6NCwiZG9tYWluSWQiOjMzMjgsImV4dCI6MjA5LCJjb21wYW55SWQiOjMzNjIsImVuZXRlcHJpc2VpZCI6ODAzMiwiaG9zdEFkZHJlc3MiOiI4MDMyLnVyY2hhdC51bmlmaWVkcmluZy5jby51ayIsIm9yZGVySWQiOjExMDE4LCJkaXJVc2VySWQiOjMyNjI0LCJpYXQiOjE2MjM3NTQ3ODd9.cR2-rh9bxex3riXVPlHW69gNRqZzDR8Tt6ewhuC9eXg",
          // Authorization: util.getLocalStorage("reactSSOToken"),
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  public static async urPatch(data: any, endPoint: any) {
    //const url: any = config().API_SERVICE_URL;
    const token: any = Cookie.get();
    return axios
      .patch(`${endPoint}`, data, {
        headers: {
          // appId: config().APP_ID,
          // appSecret: config().APP_SECRET,
          Authorization: this.getToken(),
          // authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImtyaXNobmFrdW1hci5zQHZlY3RvbmUuY29tIiwicGFzc3dvcmQiOiJrcmlzaG5hQDg2NiIsImRldmljZUlkIjoiMTU1LWhkbmRuLXdldXdpZWUiLCJzaXBMb2dpbklkIjoiNTM2NCIsInJvbGVJZCI6NCwiZG9tYWluSWQiOjMzMjgsImV4dCI6MjA5LCJjb21wYW55SWQiOjMzNjIsImVuZXRlcHJpc2VpZCI6ODAzMiwiaG9zdEFkZHJlc3MiOiI4MDMyLnVyY2hhdC51bmlmaWVkcmluZy5jby51ayIsIm9yZGVySWQiOjExMDE4LCJkaXJVc2VySWQiOjMyNjI0LCJpYXQiOjE2MjM3NTQ3ODd9.cR2-rh9bxex3riXVPlHW69gNRqZzDR8Tt6ewhuC9eXg",
          // Authorization: util.getLocalStorage("reactSSOToken"),
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  public static async shopifyCancelDel(url: string, token: string) {
    console.log("shopifyCancelDel", url);
    return axios.delete(`${url}`, {
      headers: {
        Authorization: token
      }
    }).then((response: any) => {
      console.log("response-----", response);
      return response.data;
    }).catch((err) => {
      console.log("err----", err);
    });

  }
}

export const worktualTeamsSync = async (payload:any,headers:any) => {
  try{
    return await axios.post(`${API_ROUTE_CONTROLLER.directRouting_sync}`,payload,{headers})
    .then((resp) => { return resp.data})
    .catch((err) => { return err})
  }catch(err){
    console.log("err in worktualTeamsSync-----------",err)
  }
}
